import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './Login';
import { toast } from 'react-toastify';
import BuilderService from '../../services/BuilderService';
import { useUserDetails } from '../../../redux/hooks/UserDetails';

declare global {
  interface Window {
    google: any;
  }
}
export default function LoginWrapper() {
  const navigate = useNavigate();
  const builderService = new BuilderService();
  const { userDetail } = useUserDetails();
  const handleSubmit = async (email: string, password: string) => {
    try {
      const response = await builderService.login(
        email,
        password
      );

      if (response.success) {
        await new Promise((r)=>setTimeout(r,500))
         const sessionValid = await builderService
          .checkSessionValidity()
   
          .then((r) =>{
            return r?.data?.exists === true
          })
          .catch((err) => {
            console.error('Session invalid:', err);
            return false;
          });

        if (!sessionValid) {
          toast.warn('Third-party cookies are blocked. Please enable them to continue.');
          return;
        }

        toast.success('Login successful!');
        navigate('/');
      } 
    } catch (error: any) {
      toast.error(error && error.response  && error.response.data && error.response.data.message);
    }
  };


  useEffect(() => {
      if (userDetail) {
        console.log("user loggedin:", userDetail);
        navigate('/');
    }
  }, [userDetail, navigate]);

 

  return (
    <LoginForm
      onSubmit={handleSubmit}
      onForgotPassword={() => navigate('/forgotPassword')}
      onSignupClick={() => navigate('/signup')}
    />
  );
}